import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ requiredRole, children }) {
  const role = localStorage.getItem('role');

  if (role !== requiredRole) {
    return <Navigate to="/admin-login" replace />;
  }
  return children;
}

export default ProtectedRoute;